import { ICollection } from "../Collection";

// an administrative grouping of entities that are adressed and treated as a unit for some purpose. These entities may have some spatial arrangement (e.g., an apartment is typically contiguous) but that is not a requirement (see, e.g., a distributed campus consisting of spatially disjoint plots or buildings).
export interface IPortfolioInsights extends ICollection {
}

export const schema = 'AutomationApps.Collections.PortfolioInsights'
export const modelId = 'dtmi:AutomationApps:Collections:PortfolioInsights'